import { Sprite } from './Sprite';

export class Image extends Sprite {}
